const doc = [({"ko":({"adminConstantHotelStayType":({"allTypes":"숙박 및 당일 여행", "oneDayTrip":"당일치기만 가능", "stay":"숙박만"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;